import CountryPageRenderer from '../components/CountryPageRenderer';
import maltaData from '../data/country-pages/malta';

export default function MaltaCountryPage() {
  return <CountryPageRenderer data={maltaData} />;
}
